import { useSWR } from 'modules/network/hooks/useSwr'
import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'
import { PoolAsset } from '../constants/poolAssets'
import { useConnectorAssetERC20Rpc } from 'modules/pools/hooks/useConnectorAssetERC20'

export function useAssetBalance(asset: PoolAsset | undefined | '') {
  const { walletAddress } = useWeb3()
  const connectAssetContract = useConnectorAssetERC20Rpc()

  const data = useSWR(
    asset ? `asset-balance-${walletAddress}-${asset}` : null,
    async () => {
      if (!asset || !walletAddress) return null
      const contract = connectAssetContract(asset)
      const balance = await contract.balanceOf(walletAddress)

      return balance
    },
  )

  return data
}
